import PortalIdParser from 'PortalIdParser';
import apiClient from '../utils//SPMRedirectNoAuthApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import LegalConsentRecord from '../records/LegalConsentRecord';
import { getConsentFormWrapRpc, submitViewerFormRpc } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsPublicGDPRService';
const BASE_URL = 'presentations/v1';
export const fetchLegalConsent = (presentationId, accessId) => apiClient.get(`${BASE_URL}/gdpr/public/presentations/${presentationId}/viewer-form`, {
  query: {
    portalId: PortalIdParser.get(),
    accessId
  }
}).then(res => {
  return LegalConsentRecord.fromJS(res);
});
export const fetchLegalConsentCHIRP = (presentationId, accessId) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  return rpcClient.call(getConsentFormWrapRpc, {
    request: {
      documentId: presentationId,
      accessId
    }
  });
};
// Expected HTTP 204 - No Content
export const postLegalConsentFeedback = ({
  presentationId,
  accessId,
  formGuid,
  email,
  deckLegalConsentEnabled,
  consentReceived,
  communicationTypeId,
  legalConsentOptions
}) => apiClient.post(`${BASE_URL}/gdpr/public/presentations/viewer-form`, {
  data: {
    portalId: PortalIdParser.get(),
    presentationId,
    accessId,
    formGuid,
    email,
    deckLegalConsentEnabled,
    consentReceived,
    communicationTypeId,
    legalConsentOptions
  }
});
export const postLegalConsentFeedbackCHIRP = ({
  documentId,
  accessId,
  formGuid,
  email,
  consentReceived,
  communicationTypeId,
  legalConsentOptions
}) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: apiClient
  });
  return rpcClient.call(submitViewerFormRpc, {
    request: {
      documentId,
      accessId,
      formGuid,
      email,
      consentReceived,
      communicationTypeId,
      legalConsentOptions
    }
  });
};